<template>
  <v-text-field label="Codice" v-model="properties.codice_rilievo">
    <template v-slot:append>
      <v-btn size="" color="primary" @click="copy2clipboard(properties.codice_rilievo)" class="pa-4"
          :disabled="!properties.codice_rilievo">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </template>
  </v-text-field>




  <v-text-field hide-details :readonly="true" :value="reprLocale" type="text" class="mb-6">

    <template v-slot:append><v-btn prepend-icon="mdi-calendar" class="pa-4" size color="primary"
          :disabled="isFormReadOnly">

        <v-dialog v-model="dialogSelectDate" activator="parent" width="auto" theme="dark">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row justify="space-around">
                  <v-date-picker v-model="selectedDate" show-adjacent-months color="blue-darken-3"
                      @update:modelValue="selectedDateChanged" :max="todayISOString" :min="minDate">
                    <template #title>
                      seleziona data
                    </template>
                  </v-date-picker>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions class="flex-column">
              <v-btn size="large" variant="elevated" color="blue-darken-3" @click="selectToday">
                <template v-slot:prepend>
                  <v-icon class="ml-2">mdi-calendar-star-four-points</v-icon>
                </template>
                Oggi
              </v-btn>
              <v-btn size="large" variant="outlined" color="white" @click="dialogSelectDate = false" class="mx-0 my-3">

                <template v-slot:prepend>
                  <v-icon class="ml-2">mdi-chevron-down</v-icon>
                </template>
                Indietro</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
    </template>
  </v-text-field>


  <v-autocomplete v-model="properties.autore" label="Autore" :items="dataChlorophyll.data.autore" item-title="nome"
      item-value="codice_autore" hide-details class="mb-6"></v-autocomplete>

  <v-autocomplete v-model="properties.altri_autori" multiple label="Altri autori - multiplo"
      :items="dataChlorophyll.data.autore" item-title="nome" item-value="codice_autore" hide-details
      class="mb-6"></v-autocomplete>

  <v-select v-model="properties.tipo__codice" label="Tipo" :items="dataChlorophyll.data.tipo" item-title="descrizione"
      item-value="codice" hide-details class="mb-6"></v-select>

  <v-autocomplete v-model="properties.habitat__codice" label="Habitat" :items="dataChlorophyll.data.habitat" clearable
      item-value="codice" item-title="codice" :hint="habitatHint" persistent-hint class="mb-6"></v-autocomplete>

  <v-number-input label="Area, metri quadrati" v-model="properties.superficie" :min="1" :max="300" class="mb-6"
      suffix="m²">
  </v-number-input>

  <CardinalChooser label="Esposizione" :resolution="45" class="mb-6" v-model="properties.esposizione__codice"
      :clearable="true" />


  <div>

    <v-number-input v-model="properties.inclinazione" label="Inclinazione, gradi" :min="0" :max="90"
        suffix="°" />
    <v-slider v-model="properties.inclinazione" :min="0" :max="90" :step="5" thumb-size="24" :disabled="isFormReadOnly">
      <template v-slot:append>
      </template>
    </v-slider>
  </div>

  <v-select v-model="properties.substrato__codice_substrato" label="Substrato" :items="dataChlorophyll.data.substrato"
      item-title="substrato" item-value="codice_substrato"></v-select>

  <v-select v-model="properties.progetto__codice_progetto_pngp" label="Progetto" :items="dataChlorophyll.data.progetto"
      :item-title="'descrizione'" :item-value="'codice_progetto_pngp'"></v-select>

  <v-autocomplete v-model="properties.bibliografia__codice" label="Bibliografia"
      :items="dataChlorophyll.data.bibliografia" item-title="codice_bibliografia"
      item-value="codice_biblio"></v-autocomplete>

  <v-card class="mt-0 mb-6 pa-0" :border="true" flat>
    <v-row>
      <v-col>
        <p class="text-headline-small px-4 py-2">Stime coperture %</p>
        <v-table class="">
          <template v-slot:default>
            <tbody>
              <tr>
                <td>Arboreo</td>
                <td>
                  <v-number-input :precision="2"
                      v-model="properties.stima_copertura_arboreo" :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Arbustivo</td>
                <td>
                  <v-number-input :precision="2"
                      v-model="properties.stima_copertura_arbustivo" :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Erbaceo</td>
                <td>
                  <v-number-input :precision="2"
                      v-model="properties.stima_copertura_erbaceo" :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Muscinale</td>
                <td>
                  <v-number-input :precision="2"
                      v-model="properties.stima_copertura_muscinale" :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Licheni</td>
                <td>
                  <v-number-input :precision="2"
                      v-model="properties.stima_copertura_licheni" :min="0" :max="100" />
                </td>
              </tr>
            </tbody>
          </template>
        </v-table>
      </v-col>
    </v-row>
  </v-card>


  <v-card class="mt-0 mb-6 pa-0" :border="true" flat>
    <v-row>
      <v-col>
        <p class="text-headline-small px-4 py-2">Coperture %</p>
        <v-table>
          <template v-slot:default>
            <thead class="bg-blue-grey-lighten-4">
              <tr>
                <th class="text-left" colspan="2">Fondo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Licheni</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_licheni"
                      :min="0" :max="100" />

                </td>
              </tr>
              <tr>
                <td>Roccia</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_roccia"
                      :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Detrito</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_detrito"
                      :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Sabbia</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_sabbia"
                      :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Limo</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_limo"
                      :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Suolo nudo</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_suolo_nudo"
                      :min="0" :max="100" />
                </td>
              </tr>
              <tr>
                <td>Acqua</td>
                <td>
                  <v-number-input :precision="2" v-model="properties.copertura_acqua"
                      :min="0" :max="100" />
                </td>
              </tr>
              <!-- <tr class="vegetal">
                <td>Muscinale (B)</td>
                <td class="text-right">
                  ( {{ muscinale }} )
                </td>
              </tr>
              <tr class="vegetal">
                <td>Erbaceo/Legn. &lt; 1.5 m (V)</td>
                <td class="text-right">
                  ( {{ erbaceo }} )
                </td>
              </tr>
              <tr class="vegetal">
                <td>Vegetale &lt; 1.5 m (B+V)</td>
                <td class="text-right">
                  {{ vegetale }}
                </td>
              </tr> -->
            </tbody>
          </template>
        </v-table>
        <v-list class="mt-3">
          <v-list-item :border="'xs'" :title="'Fondo'" class="bg-blue-grey-lighten-4 ">
            <template v-slot:append><span class="text-title-large ml-3">{{ coperturaFondo }}</span></template>
          </v-list-item>
          <v-list-item v-for="(strato, index) of strati" :key="index" :border="'xs'" :title="strato.title" :class="[
            coperturaByStrato(strato.value) <= 100 ? strato.bgColor : 'bg-red-darken-3',
            'd-flex', 'justify-space-between', 'align-center']">
            <template v-slot:append><span class="text-title-large ml-3">{{ coperturaByStrato(strato.value) }}</span></template>
          </v-list-item>
        </v-list>
        <p :class="['bg-blue-darken-3', 'd-flex', 'justify-space-between', 'align-center']">
          <span class="text-title-large pa-4">Totale</span>
          <span class="text-title-large pa-4">
            <output name="totale">{{ totale }}</output>
          </span>
        </p>
      </v-col>
    </v-row>
  </v-card>




  <v-card class="mt-0 mb-6 pa-3" theme="light" :border="true" flat>
    <v-card-title>
      <p class="pb-0 ma-0 text-headline-small">Taxa</p>
    </v-card-title>

    <v-card-text class="px-0">

      <!-- <v-dialog width="auto" style="max-height: 90vh"  v-if="!isFormReadOnly && taxaPool"> -->
      <v-dialog width="auto" style="max-height: 90vh"  v-if="!isFormReadOnly">
        <template v-slot:activator="{ props }">
          <v-btn size="x-large" v-bind="props" color="success" variant="flat" class="" style="" :block="mobile">
            <v-icon class="">mdi-plus</v-icon> aggiungi
          </v-btn>
        </template>
        <template v-slot:default="{ isActive }">

          <v-card theme="dark" class="mt-0 mb-6 px-3" :border="true" flat>
            <v-card-title>Aggiungi taxon</v-card-title>
            <v-card-text>

              <v-autocomplete v-model="newtaxon.id" :items="taxaPool" item-title="label" item-value="value"
                  :placeholder="placeholderTaxon" no-data-text="...non trovato" hide-details class="mb-0" clearable
                  @update:model-value="taxonUpdated">

              </v-autocomplete>

              <flora-division v-model="divisione" @update:model-value="divisionUpdated" />

              

              <v-row 
                class="mb-3"
              >
                <v-col
                  class="d-flex align-center justify-center"
                ><v-pie 
                  size="80"
                  hover-scale="0" 
                  animation
                  :items="newtaxon_copertura_items"
                />
                  </v-col>
                <v-col>
                    <v-btn class="ml-0" size="default" color="blue"
                        :style="newtaxon.copertura === 0.1 ? 'border: 4px solid #ff000066' : 'border: 4px solid transparent'"
                        variant="flat" @click="newtaxon.copertura = 0.1" block>
                      <v-icon>mdi-alpha-r</v-icon>
                    </v-btn>
                    <v-btn class="mt-2" size="default" color="lime"
                        :style="newtaxon.copertura === 0.3 ? 'border: 4px solid #ff000066' : 'border: 4px solid transparent'"
                        variant="flat" @click="newtaxon.copertura = 0.3" block>
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
              </v-row>

              <v-number-input label="Copertura, percentuale" :precision="2"
                  v-model.number="newtaxon.copertura" :min="0" :max="100"
                  @update:modelValue="newCopertura => { newTaxonCoperturaUpdated(parseInt(newCopertura)) }"
                  suffix="%"
                hide-details
                  >

              </v-number-input>
              <v-slider v-model="newtaxon.copertura" 
                  @update:modelValue="newCopertura => { newTaxonCoperturaUpdated(parseInt(newCopertura)) }"
              :min="0" :max="100" :step="1" thumb-size="24" :disabled="isFormReadOnly" />


              <v-select v-model.number="newtaxon.strato" label="Strato" :items="availableStrati" clearable
                  item-title="title" item-value="value" hide-details class="mb-3"></v-select>

              <v-select v-model.number="newtaxon.convalida_codice" label="Convalida"
                  :items="dataChlorophyll.data.convalida" item-title="codice_convalida" item-value="codice_convalida"
                  hide-details class="mb-3"></v-select>


              <v-expansion-panels flat variant="accordion" class="mt-3" v-model="notePanels">
                <v-expansion-panel>
                  <v-expansion-panel-title>
                    <v-icon size="small" color="grey-darken-2">mdi-book</v-icon>
                    <span class="ml-2">Note</span>
                    <!-- <span v-if="notePanels != 0">mostra</span>
                   <span v-else>nascondi</span> -->
                  </v-expansion-panel-title>
                  <v-expansion-panel-text class="pa-0">
                    <v-textarea v-model="newtaxon.note_autore" :counter="100" label="Note autore" class="ma-0 mb-3"
                        hide-details></v-textarea>
                    <v-textarea v-model="newtaxon.note" :counter="100" label="Note" class="ma-0 mb-3"
                        hide-details></v-textarea>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>

            <v-card-actions class="d-flex flex-column align-center position-sticky bg-grey-darken-4 bottom-0" style="z-index:20001;">

              <p class="text-body-medium text-center mt-2 text-yellow">
                {{ isAddEnabled.reason }}
              </p>
              <v-btn :color="isAddEnabled.color" :disabled="!isAddEnabled.bool" variant="flat"
                  @click="addTaxon(); isActive.value = false" size="x-large" class="px-5">
                aggiungi
              </v-btn>
              <v-btn variant="outlined" size="default" color="white" @click="isActive.value = false">
                <v-icon>mdi-chevron-down</v-icon>
                Indietro</v-btn>
            </v-card-actions>
          </v-card>

        </template>
      </v-dialog>

    </v-card-text>

    <v-table 
      v-if="properties.taxa && properties.taxa.length > 0"
      id="taxa-table" 
      class="ma-0"
      >
      <template v-slot:default>
        <thead>
          <tr class="bg-blue-grey">
            <th class="text-left text-white">Taxon</th>
            <th class="text-center text-white">Copertura %</th>
            <th class="text-center text-white"></th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item of properties.taxa" :key="item.id">
            <tr>
              <td colspan="3">
                <p class="pa-2 pb-0 mb-0 text-body-large text-blue-grey-darken-4">{{ getTaxaLabel(item) }}</p>
              </td>
            </tr>
            <tr>
              <td>
                <v-chip variant="flat" v-if="isTaxaMuscinale(item)" class="ml-1 mb-1" color="green" pill>B
                </v-chip>
                <v-chip variant="flat" v-if="isTaxaVascolare(item)" class="ml-1 mb-1" color="green" pill>V
                </v-chip>

                <v-chip variant="flat" class="ml-1 mb-1" color="orange" pill v-if="item.convalida_codice">
                  {{ item.convalida_codice }}
                </v-chip>

                <v-chip variant="flat" class="ml-1 mb-1" color="blue" pill>
                  {{ item.strato || "-" }}
                </v-chip>



                <v-chip variant="flat" class="ml-1 mb-1" color="blue-grey-lighten-1" v-if="item.note !== ''">
                  <v-icon size="x-small">mdi-book</v-icon>
                </v-chip>

                <v-chip variant="flat" class="ml-1 mb-1" color="blue-grey-lighten-1" v-if="item.note_autore !== ''">
                  <v-icon size="x-small">mdi-account</v-icon>
                </v-chip>
              </td>
              <td class="text-center font-weight-bold">
                <span v-if="item.copertura === 0.1"><v-icon>mdi-alpha-r</v-icon></span>
                <span v-else-if="item.copertura === 0.3"><v-icon>mdi-plus</v-icon></span>
                <span v-else>{{ item.copertura }}</span>
              </td>
              <td>


                <v-dialog width="auto" v-if="!isFormReadOnly">
                  <template v-slot:activator="{ props }">
                    <v-btn v-bind="props" fab x-small color="red" size="" class="pa-2" dark>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>

                  <template v-slot:default="{ isActive }">
                    <v-card theme="dark">
                      <v-card-item>
                        <v-card-title>Eliminazione</v-card-title>
                        <v-card-subtitle>Stai per eliminare il taxa</v-card-subtitle>
                      </v-card-item>
                      <v-card-text>
                        <p class="mb-2">
                          Sei sicuro di voler eliminare il taxa
                          <br>
                          {{ getTaxaLabel(item) }}?

                        </p>
                      </v-card-text>

                      <v-card-actions class="d-flex flex-column align-center ">
                        <v-btn variant="flat" size="large" color="red-darken-2" class="my-1" @click="deleteTaxon(item)">
                          <v-icon>mdi-delete</v-icon>
                          Elimina</v-btn>
                        <v-btn variant="outlined" size="large" color="white" class="my-1 mx-0"
                            @click="isActive.value = false">
                          <v-icon>mdi-chevron-down</v-icon>
                          Indietro</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                </v-dialog>
              </td>
            </tr>

          </template>
        </tbody>
      </template>
    </v-table>
    <p v-else 
      class="text-center"
      >
    Lista vuota
    </p>

  </v-card>



  <v-card class="mt-0 mb-6 pa-3" theme="light" :border="true" flat>
    <v-card-title>
      <p class="pb-0 ma-0 text-headline-small">Note generali</p>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-textarea v-model="properties.note" :counter="100" placeholder="..."></v-textarea>
    </v-card-text>

  </v-card>

</template>

<script setup>
import CardinalChooser from "@/reports/components/CardinalChooser"
import FloraDivision from "@/reports/components/FloraDivision"
import { useToastsStore } from "@/store/toasts"


import { ref, computed, onMounted, inject, nextTick } from "vue"

import dataChlorophyll from '@/assets/catalog/ChlorophyllData.json'
import dataTracker from '@/assets/catalog/TrackerForms.json'


import { useCopyToClipboard } from "@/service/copyToClipboard";

import { useDisplay } from 'vuetify'


const { copy2clipboard } = useCopyToClipboard();


// debugger
const isFormReadOnly = ref(false)

const toastsStore = useToastsStore();
// console.log("dataChlorophyll")
// console.log(dataChlorophyll)

const { mobile } = useDisplay()

const properties = defineModel()

const divisione = ref(false)

const newtaxon_copertura_items = computed(()=>{
  if (newtaxon.value.copertura) {
    return [
      { key: 1, title: 'Copertura', value: newtaxon.value.copertura, color: '#E65100' },
      { key: 2, title: 'Rimanente', value: 100 - newtaxon.value.copertura, color: '#0000' },
    ]
  }
  return  []
})
// questo è presente solo su chlorophyll... quindi per ora statico,
// schiantato
const strati = ref([{
  title: "Strato non specificato",
  value: null,
  divisionsAcceptable: ["B", "V", false],
  bgColor: "bg-grey-lighten-4"
},
{
  title: "Muscinale",
  value: "mu",
  divisionsAcceptable: ["B", false],
  bgColor: "bg-lime-lighten-4"
},
{
  title: "Erbaceo",
  value: "e",
  divisionsAcceptable: ["V", false],
  bgColor: "bg-lime-lighten-4"
},
{
  title: "Arbustivo inferiore",
  value: "ai",
  divisionsAcceptable: ["V", false],
  bgColor: "bg-lime-lighten-4"
},
{
  title: "Arbustivo superiore",
  value: "as",
  divisionsAcceptable: ["V", false],
  bgColor: "bg-lime-lighten-4"
},
{
  title: "Arboreo inferiore",
  value: "Ai",
  divisionsAcceptable: ["V", false],
  bgColor: "bg-lime-lighten-4"
},
{
  title: "Arboreo superiore",
  value: "As",
  divisionsAcceptable: ["V", false],
  bgColor: "bg-lime-lighten-4"
}
])






if (!properties.value?.taxa) {
  properties.value.taxa = []
}

// eslint-disable-next-line no-unused-vars
const props = defineProps({
  "isNew": {
    type: Boolean,
    default: false
  }
})

// console.log(properties)

// Object.assign(properties.value.properties, {
//   codice_rilievo: "",
//   tipo__codice: "PER",
//   habitat__codice: "",
//   superficie: 1,
//   esposizione__codice: null,
//   inclinazione: 0,
//   substrato__codice_substrato: 0,
//   progetto__codice_progetto_pngp: 0,
//   bibliografia__codice: 0,
//   copertura_roccia: 0,
//   copertura_limo: 0,
//   copertura_sabbia: 0,
//   copertura_detrito: 0,
//   copertura_suolo_nudo: 0,
//   copertura_acqua: 0,
//   copertura_arboreo: 0,
//   copertura_arbustivo: 0,
//   copertura_licheni: 0,
//   copertura_muscinale: 0,
//   copertura_erbaceo: 0,
//   copertura_vegetale: 0,
//   copertura_totale: 0,
//   EPSG: 4326,
//   lon: 0,
//   lat: 0,
//   data: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
//     .toISOString()
//     .substr(0, 10),
//   taxa: [],
// })



// const properties = ref(properties.value.properties)






const newtaxon = ref({
  id: null,
  copertura: 0,
  convalida_codice: "A",
  note_autore: "",
  note: "",
  strato: null
})

const notePanels = ref(undefined)

const dialogSelectDate = ref(false);

const selectedDate = ref(null)

// ten days ago

const minDate = computed(() => {
  return (new Date(Date.now() - 100 * 24 * 60 * 60 * 1000)).toISOString()
})

const today = computed(() => {
  return new Date(Date.now())
})





const todayISOString = computed(() => {
  // return (new Date(today)).value
  return today.value.toISOString()
})




const reprLocale = computed(() => {
  const a = new Date(selectedDate.value).toLocaleDateString()
  const b = new Date(selectedDate.value).toLocaleTimeString()
  return a + " " + b
  // toLocaleDateString()
})



const availableStrati = computed(() => {
  return strati.value.filter((elem) => {
    return elem.divisionsAcceptable.includes(divisione.value)
  })
})



const taxonUpdated = () => {

  nextTick(() => {
    updateStrato()
  })

}


const updateStrato = async () => {
  // console.log("updateStrato")
  if (!newtaxon.value.id) { return }

  await nextTick()  // bisogna attendere che il valore di newtaxon sia effettivamente cambiato

  const strato = availableStrati.value.find((elem) => {
    return elem.value === newtaxon.value.strato
  })

  if (strato) { return }

  newtaxon.value.strato = availableStrati.value.filter((elem) => {
    return elem.value !== null
  })[0].value

}



const divisionUpdated = () => {

  updateStrato()
  // 
  if (!newtaxon.value.id) { return }

  const taxon = taxaPool.value.find((elem) => {
    return elem.value === newtaxon.value.id
  })

  if (taxon) { return }

  newtaxon.value.id = taxaPool.value[0].value

}

const selectToday = () => {
  selectedDate.value = new Date(Date.now())
  dialogSelectDate.value = false
}



const selectedDateChanged = () => {
  dialogSelectDate.value = false
  const twelvehours = 12 * 60 * 60 * 1000
  selectedDate.value.setTime(selectedDate.value.getTime() + twelvehours);
  properties.value.timestamp = selectedDate.value.valueOf()
  properties.value.data = new Date(properties.value.timestamp - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substring(0, 10)

  setLabel()
}


const taxaPool = computed(() => {


  // solo le fitosociologia
  let taxa = dataTracker.lookup.flora.filter((elem) => {
    return elem.fitosociologia === true
  })

  // solo le divisione attiva
  if (divisione.value) {
    taxa = dataTracker.lookup.flora.filter((elem) => {
      return elem.divisione === divisione.value
    })
  }

  // order
  const taxa_ordered = taxa.sort((a, b) => {
    return a.label > b.label ? 1 : -1
  })

  return taxa_ordered
})

const placeholderTaxon = computed(() => {

  let asd = 0
  if (taxaPool?.value) {
    asd = taxaPool.value.length
  }
  return `Cerca per binomio (${asd})`
})


const isAddEnabled = computed(() => {

  if (isFormReadOnly.value) {
    // console.log("returning false, isFormReadOnly")
    return {
      bool: false,
      color: "grey-darken-4",
      reason: "isFormReadOnly"
    }
  }

  if (!newtaxon.value.id) {
    // console.log("returning false, id meh")
    return {
      bool: false,
      color: "grey-darken-4",
      reason: "seleziona taxon"
    }
  }
  if (newtaxon.value.copertura === 0) {
    // console.log("returning false, copertura meh")
    return {
      bool: false,
      color: "grey-darken-4",
      reason: "copertura non sufficiente"
    }
  }

  if (properties.value.taxa.find((elem) => {
    return elem.id === newtaxon.value.id
  })) {
    // console.log("returning false, newtaxon found")

    // console.log(taxaPool.value)
    // console.log(newtaxon.value)
    const taxaFromTaxaPool = taxaPool.value.find((elem) => {
      return elem.value === newtaxon.value.id
    })

    const lowercaselabel = taxaFromTaxaPool.label.toLowerCase()
    console.log(lowercaselabel)

    if (lowercaselabel.includes("sconosciuto")) {
      return {
        bool: true,
        color: "orange",
        reason: "taxon già censito"
      }
    }

    return {
      bool: false,
      color: "grey-darken-4",
      reason: "taxon già censito"
    }
  }


  return {
    bool: true,
    color: "success",
    reason: ""
  }

})


const habitatHint = computed(() => {
  if (!properties.value.habitat__codice) {
    return "..."
  }
  return dataChlorophyll.data.habitat.find((elem) => {
    return elem.codice === properties.value.habitat__codice
  }).descrizione
})


const newTaxonCoperturaUpdated = async (newCopertura) => {
  // console.log("= = = = = = = = = = = = = = = = = = ")

  // console.log(newCopertura)

  if (newCopertura === 0) {
    newtaxon.value.copertura = .1
    return
  }


  if (newCopertura > 100) {
    newtaxon.value.copertura = 100
    return
  }

  if (newCopertura > 1) {
    // const toIntFloated = parseFloat(parseInt(newCopertura))
    // const toFloat = parseFloat(newCopertura)
    // // console.log(`toIntFloated: ${toIntFloated} toFloat: ${toFloat}`)
    // if (toIntFloated !== toFloat) {
    //   // console.log("need mod")
    //   newtaxon.value.copertura = Math.round(newCopertura)
    //   return
    // }
  }
}

const addTaxon = () => {
  console.log(newtaxon.value)

  console.log(dataTracker.lookup.flora.find((elem) => {
    return elem.value === newtaxon.value.id
  }) || "not found")

  const localTaxon = {
    id: newtaxon.value.id,
    copertura: newtaxon.value.copertura,
    convalida_codice: newtaxon.value.convalida_codice,
    note: newtaxon.value.note,
    note_autore: newtaxon.value.note_autore,
    strato: newtaxon.value.strato,
  }
  
  taxaPool.value.find((elem) => {
    if (elem.value === localTaxon.id) {
      localTaxon.label = elem.label
    }
  })

  properties.value.taxa.push(localTaxon)


  // reorder by label

  properties.value.taxa.sort((a, b) => {
    return a.label > b.label ? 1 : -1
  })

  // reset mask for eventually incoming new taxon
  newtaxon.value.id = null
  newtaxon.value.copertura = 10
  newtaxon.value.convalida_codice = "A"
  newtaxon.value.note = ""
  newtaxon.value.note_autore = ""

  setLabel()
}

// const ids_muscinali = dataTracker.lookup.flora.filter((elem) => {
//   return elem.divisione === "B"
// }).map((elem) => {
//   return elem.value
// })
// // console.log(ids_muscinali)

// const ids_erbacei = dataTracker.lookup.flora.filter((elem) => {
//   return elem.divisione === "V"
// }).map((elem) => {
//   return elem.value
// })
// // console.log(ids_erbacei)



const getTaxaLabel = (item) => {
  const label = dataTracker.lookup.flora.find((elem) => {
    // debugger
    return elem.value === item.id

  }).label || "not found"

  return label.substring(0, 20)

}

const isTaxaMuscinale = (item) => {
  const taxon = dataTracker.lookup.flora.find((elem) => {
    return elem.value === item.id
  })
  if (taxon?.divisione === "B") {
    return true
  }
  return false
}

const isTaxaVascolare = (item) => {
  // console.log(item)
  const taxon = dataTracker.lookup.flora.find((elem) => {
    return elem.value === item.id
  })
  // console.log(taxon)
  if (taxon?.divisione === "V") {
    return true
  }
  return false
}

const deleteTaxon = (item) => {
  const index = properties.value.taxa.indexOf(item)
  properties.value.taxa.splice(index, 1)

  setLabel()
}



// const muscinale = computed(() => {

//   const taxa_muscinali_collected = properties.value.taxa.filter((elem) => {
//     return ids_muscinali.includes(elem.value)
//   })

//   // console.log(taxa_muscinali_collected)
//   const copertura = taxa_muscinali_collected.reduce((total, currentElement) => {
//     if (currentElement.copertura < .4) return total
//     return total + currentElement.copertura
//   }, 0)

//   return copertura

// })


const coperturaByStrato = (strato) => {
  const taxa_collected = properties.value.taxa.filter((elem) => {
    return elem.strato === strato
  })

  const copertura = taxa_collected.reduce((total, currentElement) => {
    if (currentElement.copertura == .1) return total
    if (currentElement.copertura == .3) return total

    return total + currentElement.copertura
  }, 0)

  return copertura
}

const erbaceo = computed(() => {

  const taxa_erbacei_collected = properties.value.taxa.filter((elem) => {
    return ids_erbacei.includes(elem.id)
  })

  // console.log(taxa_erbacei_collected)
  const copertura = taxa_erbacei_collected.reduce((total, currentElement) => {
    if (currentElement.copertura < .4) return total
    return total + currentElement.copertura
  }, 0)

  return copertura

})



const coperturaFondo = computed(() => {

  let fondo = 0
  fondo += parseFloat(properties.value.copertura_licheni)
  fondo += parseFloat(properties.value.copertura_roccia)
  fondo += parseFloat(properties.value.copertura_limo)
  fondo += parseFloat(properties.value.copertura_sabbia)
  fondo += parseFloat(properties.value.copertura_detrito)
  fondo += parseFloat(properties.value.copertura_suolo_nudo)
  fondo += parseFloat(properties.value.copertura_acqua)

  return parseFloat(fondo.toFixed(2))
})

// const vegetale = computed(() => {

//   return muscinale.value + erbaceo.value

// })

const totale = computed(() => {

  let totale = 0
  totale += parseFloat(coperturaFondo.value)

  for (const strato of strati.value) {
    totale += coperturaByStrato(strato.value)
  }

  return parseFloat(totale.toFixed(2))


})



const setDefaults = () => {

  properties.value.tipo__codice = "PER"
  properties.value.superficie = 4
  properties.value.inclinazione = 0
  properties.value.esposizione = null
  properties.value.copertura_licheni = 0
  properties.value.copertura_roccia = 0
  properties.value.copertura_detrito = 0
  properties.value.copertura_sabbia = 0
  properties.value.copertura_limo = 0
  properties.value.copertura_suolo_nudo = 0
  properties.value.copertura_acqua = 0

  properties.value.stima_copertura_arboreo = 0
  properties.value.stima_copertura_arbustivo = 0
  properties.value.stima_copertura_erbaceo = 0
  properties.value.stima_copertura_muscinale = 0
  properties.value.stima_copertura_licheni = 0

  properties.value.taxa = []
  properties.value.EPSG = 4326

  properties.value.codice_rilievo = "rilievo_" + properties.value.uuid

  newtaxon.value.copertura = 10

  // properties.value.lat =  ??? 
  // properties.value.lon =  ??? 
}





const setLabel = () => {
  const howMany = properties.value.taxa.length
  const codice = properties.value.codice_rilievo
  const dateRepr = new Date(selectedDate.value).toLocaleDateString()
  const label = codice || dateRepr
  if (howMany) {
    properties.value.label = `${label} (${howMany} taxa) (${totale.value}%)`
  }
  else {
    properties.value.label = `${label}`
  }
}



onMounted(() => {

  const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
  isFormReadOnly.value = svf.isReadonly.value

  console.log("rimuovere dataChlorophyll ove possibile")

  // console.table(dataTracker.lookup.flora)
  if (properties.value.stima_copertura_muscinali) {
    properties.value.stima_copertura_muscinale = properties.value.stima_copertura_muscinali
    delete properties.value.stima_copertura_muscinali
  }


  if (props.isNew) {
    console.log("props isNew is there")
    console.log(props.isNew)
    setDefaults()
    setLabel()
  }

  if (properties.value.timestamp) {
    // console.log("restore from timestamp")
    // console.log("leggo: " + model.value.timestamp)
    selectedDate.value = new Date(properties.value.timestamp)
  }
  else {
    // console.log("new date ")
    selectedDate.value = new Date(Date.now()).valueOf()
  }


  selectedDateChanged()

})




</script>

<style scoped>
/* https://vuetifyjs.com/en/features/sass-variables/#basic-usage
$expansion-panel-text-padding
.v-expansion-panel-content:deep(.v-expansion-panel-text__wrapper) {
  padding: 0 !important;
} */

:deep(.v-chip--pill) {
  aspect-ratio: 1;
  justify-content: center;
  /* border: 1px solid #00000033; */
}


:deep(#taxa-table tbody tr:nth-child(even) td) {
  border-bottom: 1px solid #00000033;
}

:deep(#taxa-table tbody tr:nth-child(odd) td) {
  border-bottom: none;
}

:deep(#taxa-table tbody tr:nth-child(4n -1)) {
  background: #FAFAFA;
}

:deep(#taxa-table tbody tr:nth-child(4n)) {
  background: #FAFAFA;
}

:deep(#taxa-table tbody tr:nth-child(4n +1)) {
  background: #ECEFF1;
}

:deep(#taxa-table tbody tr:nth-child(4n +2)) {
  background: #ECEFF1;
}


</style>
